<div class="container container_type_main">

  <div class="subtitle h2 mt-32">{{ 'genres-page.title' | translate }}</div>
  <div class="page-tabs__container">
    <div class="page-tabs__arrow page-tabs__prev page-tabs__arrow-disabled icon-chevron-left" (click)="leftScroll()"></div>
    <div class="page-tabs">
      <div class="page-tabs__item" [class.page-tabs__item-active]="!tagId" (click)="openAll()">
        <div class="page-tabs__link">{{ 'genres-page.all-tracks' | translate }}</div>
      </div>
      <div class="page-tabs__item" *ngFor="let tag of tags" [class.page-tabs__item-active]="tagId && tag.id == tagId" (click)="openTag(tag.id)">
        <div class="page-tabs__link">{{ tag.title }}<i [ngClass]="getIconClass(tag)"></i></div>
      </div>
    </div>
    <div class="page-tabs__arrow page-tabs__next icon-chevron-right" (click)="rightScroll()"></div>
  </div>
  <div class="filters">
    <div class="filters__item" (click)="changeSort(false)" [class.filters__item-active]="!sortByTitle">
      <div class="filters__link">{{ 'genres-page.popular-sort' | translate }}</div>
    </div>
    <div class="filters__item" (click)="changeSort(true)" [class.filters__item-active]="sortByTitle">
      <div class="filters__link">{{ 'genres-page.title-sort' | translate }}</div>
    </div>
  </div>

  <div class="songs-list">
    <div *ngFor="let melody of melodies" class="songs-list__item" app-melody-item [melody]="melody"></div>
  </div>

  <div class="full-button" *ngIf="melodies.length < melodiesCount" (click)="loadMelodiesPage()">
    <div class="button button_type_light" [class.button_type_load]="loadInProgress" [class.with-icon]="loadInProgress">{{ 'show-more' | translate }}</div>
  </div>

  <app-hit-melodies [melodies]="hitsMelodies" [showSubtitle]="false"></app-hit-melodies>

  <app-privet-plus-banner [specialBanners] = "mainPageSpecialBanners"></app-privet-plus-banner>

</div>
